import Isotope from "isotope-layout"
import numeral from "numeral"
import { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'

// Mapa fixo de alergénios para números (baseado na tabela padrão EU)
const ALLERGEN_MAP = {
  'Glúten': 1, 'Gluten': 1,
  'Crustáceos': 2, 'Crustaceans': 2, 'Crustacés': 2,
  'Ovos': 3, 'Eggs': 3, 'Œufs': 3,
  'Peixe': 4, 'Fish': 4, 'Poisson': 4,
  'Amendoim': 5, 'Peanuts': 5, 'Arachides': 5,
  'Soja': 6, 'Soy': 6,
  'Leite': 7, 'Milk': 7, 'Lait': 7,
  'Frutos de Casca Rija': 8, 'Tree Nuts': 8, 'Fruits à Coque': 8,
  'Aipo': 9, 'Celery': 9, 'Céleri': 9,
  'Mostarda': 10, 'Mustard': 10, 'Moutarde': 10,
  'Sésamo': 11, 'Sesame': 11,
  'Dióxido de Enxofre e Sulfitos': 12, 'Sulphur Dioxide and Sulphites': 12, 'Dioxyde de Soufre et Sulfites': 12,
  'Tremoço': 13, 'Lupin': 13,
  'Moluscos': 14, 'Molluscs': 14, 'Mollusques': 14
};

const getAllergenNumber = (allergen, lang) => {
  const name = lang === 'en' ? allergen.englishName :
               lang === 'fr' ? allergen.frenchName :
               allergen.portugueseName;
  return ALLERGEN_MAP[name] || ALLERGEN_MAP[allergen.portugueseName] || null;
};

// Convert menu type name to valid CSS class name
const toValidClassName = (name) => {
  if (!name) return '';
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/[^a-zA-Z0-9]/g, '-')   // Replace non-alphanumeric with hyphen
    .replace(/-+/g, '-')              // Replace multiple hyphens with single
    .replace(/^-|-$/g, '')            // Remove leading/trailing hyphens
    .toLowerCase();
};

const IsotopeReact = ({categories, items}) => {
    const { i18n } = useTranslation();
    const lang = i18n.language || 'pt';

    // Helper to get translated category name
    const getCategoryName = (cat) => {
      if (!cat) return '';
      switch (lang) {
        case 'en': return cat.englishName || cat.name;
        case 'fr': return cat.frenchName || cat.name;
        default: return cat.name;
      }
    };

    // init one ref to store the future isotope object
    const isotope = useRef()
    // store the filter keyword in a state - initialize with first category or '*'
    const [filterKey, setFilterKey] = useState(null)
    const [selectedMenuItem, setSelectedMenuItem] = useState(null)
    const [initialized, setInitialized] = useState(false)

    // Set initial filter to first category when categories load
    useEffect(() => {
      if (categories != null && categories.length > 0 && !initialized) {
        const firstCategory = categories[0].name; // Always use Portuguese name as key
        setFilterKey(firstCategory);
        setSelectedMenuItem(firstCategory);
        setInitialized(true);
      }
    }, [categories, initialized]);

    // initialize an Isotope object with configs
    useEffect(() => {
      if(categories != null && categories.length> 0){
      isotope.current = new Isotope('.menu-group', {
        itemSelector: '.filter-item',
        layoutMode: 'masonry',
      })
      // cleanup
      return () => isotope.current.destroy()}
    }, [categories])
  
    // handling filter key change
    useEffect(() => {
      if(categories != null && categories.length> 0 && filterKey != null && isotope.current){
      filterKey === '*'
        ? isotope.current.arrange({filter: `*`})
        : isotope.current.arrange({filter: `.${toValidClassName(filterKey)}`})
      }
    }, [filterKey,categories])
  
    const handleFilterKeyChange = key => () => {setFilterKey(key); setSelectedMenuItem(key);}
    
   function fCurrency(number) {
    const format = number ? numeral(number).format('€0,0.00') : '';
  
    return result(format, ',00');
  }
  function result(format, key = '.00') {
    const isInteger = format.includes(key);
  
    return isInteger ? format.replace(key, '') : format;
  }
 
let currentCategory = null;

const renderCategory = (dish) => {
  const cat = dish.category;
  const menuType = dish.menuType;

  // Don't show category if it's the same as menuType or if it's already shown
  if (cat === menuType || cat === currentCategory) {
    return null;
  }
  currentCategory = cat;

  // Get translated category name
  const translatedCat = lang === 'en' ? (dish.categoryEnglish || cat) :
                        lang === 'fr' ? (dish.categoryFrench || cat) :
                        cat;

  return (
    <div><h3>{translatedCat}</h3></div>
  );
}
    return (
      <>
      {categories != null && categories.length > 0 ? (<>
        <ul  id="menu-fillter" className="clearfix">
          {/* <li className={selectedMenuItem === '*' ? 'activeFilter' : ''} onClick={handleFilterKeyChange('*')}><Link>Todos</Link></li> */}
          {categories.map((obj,index) =>
          <li className={selectedMenuItem === obj.name ? 'activeFilter' : ''} key={index} onClick={handleFilterKeyChange(obj.name)}>
            <Link>{getCategoryName(obj)}</Link>
            </li>)}
        </ul>
        <div className="row menu-group">
          {items.sort((a, b) => a.categoryOrder - b.categoryOrder).map((dish,index) => {
            const lang = i18n.language || 'pt';
            const dishName = lang === 'en' ? (dish.englishName || dish.portugueseName) :
                            lang === 'fr' ? (dish.frenchName || dish.portugueseName) :
                            dish.portugueseName;
            const dishDescription = lang === 'en' ? (dish.englishDescription || dish.portugueseDescription) :
                                   lang === 'fr' ? (dish.frenchDescription || dish.portugueseDescription) :
                                   dish.portugueseDescription;
            const allergens = dish.allergens || [];
            const allergenNumbers = allergens
              .map(a => getAllergenNumber(a, lang))
              .filter(n => n !== null)
              .sort((a, b) => a - b);

            return (
            <div className={`col-md-12 filter-item ${toValidClassName(dish.menuType)}`} key={index} style={{width:'100%'}}>
             {renderCategory(dish)}
            <div className="col-md-12">
            <div className="menu-item-text">
              <h3 className="menu-item-heading">
                <span className="menu-item-name" style={{fontSize:'70%', textAlign:'justify',display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {dishName}
                  {allergenNumbers.length > 0 && (
                    <sup style={{ fontSize: '10px', color: '#999', marginLeft: '4px' }}>
                      ({allergenNumbers.join(', ')})
                    </sup>
                  )}
                </span>
                <div className="menu-item-dots"></div>
                <span className="menu-item-price" style={{fontSize:'70%'}} >{fCurrency(dish.cost)} €</span>
              </h3>
              {(dishDescription && dishDescription !== '' && dishDescription !== 'null') &&
              <p className="menu-item-desc" style={{ fontSize:'70%',float:"left", textAlign:'justify'}}>
                {dishDescription}
              </p> }
            </div>
          </div>
            </div>
          )})}
        </div></>)
          : null}</>
    )
  }

  export default IsotopeReact;